module.exports = __webpack_public_path__ + "img/user-bg.095bff8b.png";